export default "__VITE_ASSET__Bvb2aBks__"